import { Box, ResponsiveContainer, styled } from '@arpeggi/ui'

const Root = styled(Box, {
  position: 'sticky',
  top: 0,
  background: '$whiteA700',
  backdropFilter: 'blur(8px)',
  height: '60px',
  boxSizing: 'border-box',
  borderBottomColor: '$blackA100',
  borderBottomStyle: 'solid',
  borderBottomWidth: '1px',
  zIndex: 1
})

const Content = styled(ResponsiveContainer, {
  height: '100%',
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'space-between'
})

const TabArea = styled('div', {
  display: 'flex',
  alignItems: 'stretch'
})

const Actions = styled('div', {
  display: 'flex',
  alignItems: 'center'
})

export const Navbar = { Root, Content, TabArea, Actions }
